module.exports = swt.map;